const Codenames = {
  Packmanager: "Shop Floor Control Module",
  PackmanagerShort: "Shop Floor",
};

export default Codenames;
